import {theme} from "../../js/core";

export class SimpleGoogleMap {
  constructor(mapRoot) {
    this.root = mapRoot instanceof jQuery ? mapRoot : $(mapRoot);
    this.markersData = this.root.find('.marker');
    this.markersData.detach();
    
    this.map = null;
  }
  
  static create(mapRoot) {
    return new SimpleGoogleMap(mapRoot);
  }
  
  /**
   *
   * @param {Object} args
   * @returns {SimpleGoogleMap|bool}
   */
  newMap(args) {
    if (!google || typeof google.maps === "undefined") {
      theme.console.warn("Google maps API is not loaded");
      return false;
    }
    
    let defaults = {
      zoom: 16,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: false,
      styles: [{"featureType":"administrative.locality","elementType":"all","stylers":[{"hue":"#2c2e33"},{"saturation":7},{"lightness":19},{"visibility":"on"}]},{"featureType":"landscape","elementType":"all","stylers":[{"hue":"#ffffff"},{"saturation":-100},{"lightness":100},{"visibility":"simplified"}]},{"featureType":"poi","elementType":"all","stylers":[{"hue":"#ffffff"},{"saturation":-100},{"lightness":100},{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"hue":"#bbc0c4"},{"saturation":-93},{"lightness":31},{"visibility":"simplified"}]},{"featureType":"road","elementType":"labels","stylers":[{"hue":"#bbc0c4"},{"saturation":-93},{"lightness":31},{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"labels","stylers":[{"hue":"#bbc0c4"},{"saturation":-93},{"lightness":-2},{"visibility":"simplified"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"hue":"#e9ebed"},{"saturation":-90},{"lightness":-8},{"visibility":"simplified"}]},{"featureType":"transit","elementType":"all","stylers":[{"hue":"#e9ebed"},{"saturation":10},{"lightness":69},{"visibility":"on"}]},{"featureType":"water","elementType":"all","stylers":[{"hue":"#e9ebed"},{"saturation":-78},{"lightness":67},{"visibility":"simplified"}]}]
    };
  
    if (typeof args !== "undefined" && args instanceof Object) {
      for (let prop in defaults) {
        if (defaults.hasOwnProperty(prop)) {
          if (typeof args[prop] === "undefined") args[prop] = defaults[prop];
        }
      }
    } else {
      args = defaults;
    }
    
    // create map
    this.map = new google.maps.Map(this.root.get(0), args);
    
    // add a markers reference
    this.map.markers = [];
    
    // add markers
    this.markersData.each((i, marker) => {
      this.addMarker($(marker));
    });
    
    this.center();
    return this;
  }
  
  addMarker($marker) {
    let latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
    let marker = new google.maps.Marker({
      position: latlng,
      map: this.map
    });
    
    // if (window.waThemeClient && typeof window.waThemeClient.templateURL !== "undefined") {
    //   let image = window.waThemeClient.templateURL + "/images/map-marker.svg";
    //   marker.setOptions({icon: image});
    // }
  
    this.map.markers.push(marker);
    
    if ($marker.html()) {
      // create info window
      let infowindow = new google.maps.InfoWindow({
        content		: $marker.html()
      });
      
      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(this.map, marker);
      });
    }
    return marker;
  }
  
  center() {
    let bounds = new google.maps.LatLngBounds();
  
    this.map.markers.forEach(marker => {
      let latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      bounds.extend(latlng);
    });
    
    if (this.map.markers.length === 1) {
      // set center of map
      this.map.setCenter(bounds.getCenter());
      this.map.setZoom(16);
    } else {
      // fit to bounds
      this.map.fitBounds(bounds);
    }
  }
}
